import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  findAllUserRolesPageble,
  createUserRole,
  deleteUserRole,
  updateUserRole,
  deleteErrorUserRole,
} from '../../actions/userRole';
import UserRoleTable from '../UserRole/UserRoleTable';
import { HeaderTable } from '../../enums/UserRoleEnums';
import { TableContainer } from '../Reusable/TableContainer';
import ModalForAddUserRole from '../UserRole/ModalForAddUserRole';

const UserRoleList = () => {
  const dispatch = useDispatch();
  const userRoleReducer = useSelector((state) => state.userRole);

  const [show, setShow] = useState(false);

  const showModal = () => {
    setShow(true);
  };

  const clearValidationErrors = () => {
    dispatch(deleteErrorUserRole());
  };

  const handlePreviewClose = () => {
    setShow(false);
    clearValidationErrors();
  };

  const handleAdd = (role) => {
    dispatch(createUserRole(role, handlePreviewClose));
  };

  return (
    <>
      <TableContainer
        cardTitle={HeaderTable.titleForUserRoleTable}
        showModal={showModal}
      >
        <UserRoleTable
          dispatch={dispatch}
          userRoleReducer={userRoleReducer}
          findAllUserRolesPageble={findAllUserRolesPageble}
          updateUserRole={updateUserRole}
          deleteUserRole={deleteUserRole}
          clearValidationErrors={clearValidationErrors}
        />
      </TableContainer>
      {show && (
        <ModalForAddUserRole
          userRoleReducer={userRoleReducer}
          handleAdd={handleAdd}
          handleClose={handlePreviewClose}
          show={show}
        />
      )}
    </>
  );
};

export default UserRoleList;
